import utils from '../../utils/tag-name';

const TAG_NAME = utils.constructTagName('brandvisual');

export { TAG_NAME };
